export const NonDraggableEvents = [
  { eventType: "period", subType: "start" },
  { eventType: "period", subType: "end" },
];

export const NonClockEditableEvents = [
  { eventType: "period", subType: "start" },
  { eventType: "period", subType: "end" },
];
